<script setup lang="ts">
const props = defineProps({
  filter: {
    type: Boolean,
    default: false
  },
  position: {
    type: String,
    default: 'bottom'
  }
})

const isTop = computed(() => props.position === 'top')
</script>

<template>
  <div
    :class="[
      isTop
        ? 'top-8'
        : 'bottom-8',
      filter ? 'h-auto rounded-md p-8' : 'h-[60px]',
      isTop
        ? 'w-fit max-w-[96vw] px-4'
        : 'w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] 2xl:w-[30%]'
    ]"
    class="justify-center flex flex-col inset-x-0 mx-auto fixed z-[9999] bg-gray-900 rounded-full after:rounded-full border border-1 border-white/30"
  >
    <slot name="filter" />
    <div
      class="flex items-center h-full z-50"
      :class="filter ? 'pt-6' : 'pl-6 pr-4 gap-3'"
    >
      <slot name="logo" />
      <slot name="separator" />
      <div
        class="text-white text-sm min-w-0"
        :class="{
          'px-2': !filter,
          'flex-1': !filter && !isTop
        }"
      >
        <slot name="menulinks" />
      </div>
    </div>
  </div>
</template>
